export default "__VITE_ASSET__kofF4MKa__"